import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetTermsAcceptanceQueryVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
  actiontypeId: Types.Scalars['smallint']['input'];
}>;


export type GetTermsAcceptanceQuery = { __typename?: 'query_root', usereventlogs: Array<{ __typename?: 'usereventlogs', id: number, event_time: string }> };


export const GetTermsAcceptanceDocument = gql`
    query GetTermsAcceptance($userId: bigint!, $actiontypeId: smallint!) {
  usereventlogs(
    where: {user_id: {_eq: $userId}, actiontype_id: {_eq: $actiontypeId}}
    order_by: {event_time: desc}
    limit: 1
  ) {
    id
    event_time
  }
}
    `;

/**
 * __useGetTermsAcceptanceQuery__
 *
 * To run a query within a React component, call `useGetTermsAcceptanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAcceptanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAcceptanceQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      actiontypeId: // value for 'actiontypeId'
 *   },
 * });
 */
export function useGetTermsAcceptanceQuery(baseOptions: Apollo.QueryHookOptions<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables> & ({ variables: GetTermsAcceptanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables>(GetTermsAcceptanceDocument, options);
      }
export function useGetTermsAcceptanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables>(GetTermsAcceptanceDocument, options);
        }
// @ts-ignore
export function useGetTermsAcceptanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables>;
export function useGetTermsAcceptanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsAcceptanceQuery | undefined, GetTermsAcceptanceQueryVariables>;
export function useGetTermsAcceptanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables>(GetTermsAcceptanceDocument, options);
        }
export type GetTermsAcceptanceQueryHookResult = ReturnType<typeof useGetTermsAcceptanceQuery>;
export type GetTermsAcceptanceLazyQueryHookResult = ReturnType<typeof useGetTermsAcceptanceLazyQuery>;
export type GetTermsAcceptanceSuspenseQueryHookResult = ReturnType<typeof useGetTermsAcceptanceSuspenseQuery>;
export type GetTermsAcceptanceQueryResult = Apollo.QueryResult<GetTermsAcceptanceQuery, GetTermsAcceptanceQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/auth/queries/getTermsAcceptance.query.gql}
 */
export async function getTermsAcceptance(
  variables: GetTermsAcceptanceQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetTermsAcceptanceQuery['usereventlogs']>
export async function getTermsAcceptance(
  variables: GetTermsAcceptanceQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetTermsAcceptanceQuery>
export async function getTermsAcceptance(
  variables: GetTermsAcceptanceQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetTermsAcceptanceQuery['usereventlogs'] | GetTermsAcceptanceQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetTermsAcceptanceQuery>(
    GetTermsAcceptanceDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.usereventlogs
}